import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { clientServiceGetRequest } from "../Helpers/queryHelpers";
import { IClient } from "../Typings/Client";

/**
 * @description Gets all Base Clients
 * @returns UseQueryResult<IClient[]>
 */
export function useGetClientsQuery<T>(
  select?: (data: IClient[]) => T | undefined
) {
  return useQuery<IClient[], unknown, T | undefined>(
    ["clients"],
    async () => {
      const response: AxiosResponse<IClient[]> = await clientServiceGetRequest(
        "GetClients"
      );

      return response.data.map(convertDates);
    },
    { select: select }
  );
}

/**
 * @description Custom hook that selects all unassigned Clients for a User
 * @param assignedClientIds Currently assigned Client Ids from User's UserClientAttributes
 * @returns UseQueryResult<IClient[]>
 */
export const useGetUnassignedClients = (assignedClientIds: string[]) => {
  return useGetClientsQuery((clients) =>
    clients.filter((client) => !assignedClientIds.includes(client.id))
  );
};

/**
 * @description Custom hook that selects all assigned Clients for a User
 * @param assignedClientIds Currently assigned Client Ids from User's UserClientAttributes
 * @returns UseQueryResult<IClient[]>
 */
export const useGetAssignedClients = (assignedClientIds: string[]) => {
  return useGetClientsQuery((clients) =>
    clients.filter((client) => assignedClientIds.includes(client.id))
  );
};

// HELPERS

//Converts dates from JSON string to Date objects
function convertDates(client: IClient): any {
  return {
    ...client,
    dateCreated: new Date(client.dateCreated),
    dateLastUpdated: new Date(client.dateLastUpdated),
  };
}
